var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuvidoriaCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-opacity:0;opacity:0;}.cls-2{fill:#ffd400;}.cls-3{fill:#ffc20e;}.cls-4{fill:none;}.cls-5{fill:#00416b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ouvidoria-cor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xCDcones_Personalizados",
    "data-name": "\\xCDcones Personalizados"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ouvidoria"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80,16H16a8,8,0,0,0-8,8V60a8,8,0,0,0,8,8h8V80L36,68H80a8,8,0,0,0,8-8V24A8,8,0,0,0,80,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88,24V60a8,8,0,0,1-8,8H36L24,80V72L80,16A8,8,0,0,1,88,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88,24V60a8,8,0,0,1-8,8H36L24,80V68H16a8,8,0,0,1-8-8V24a8,8,0,0,1,8-8H80A8,8,0,0,1,88,24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 28,
    y: 38,
    width: 8,
    height: 8,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 44,
    y: 38,
    width: 8,
    height: 8,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60,
    y: 38,
    width: 8,
    height: 8,
    rx: 4,
    ry: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuvidoriaCor);
export default __webpack_public_path__ + "static/media/ouvidoria-cor.88e9499b35874e0b2012fa64b11e5c27.svg";
export { ForwardRef as ReactComponent };